import React from "react";

/**
 * AnnotationModal component for adding/editing annotations
 * Used for Time Signature, Key, and Tempo changes
 */
const AnnotationModal = ({ 
  title, 
  children, 
  onSave, 
  onCancel, 
  isEditing = false,
  error = ""
}) => {
  return (
    <div className="p-4 bg-white border border-gray-300 rounded-md shadow-md">
      <h3 className="text-lg font-bold mb-4">{title}</h3>
      
      <div className="mb-4">
        {children}
      </div>
      
      {error && (
        <div className="mb-4 p-2 bg-red-100 text-red-700 rounded-md">
          {error}
        </div>
      )}
      
      <div className="flex justify-end space-x-2">
        <button 
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
        >
          Cancel
        </button>
        <button 
          onClick={onSave}
          className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800"
        >
          {isEditing ? 'Update' : 'Add'}
        </button>
      </div>
    </div>
  );
};

export default AnnotationModal;
